module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/PayrollItems.ejs -->\n';
 labels = {
    addition: {
        plural: 'Additions',
        singular: 'Addition'
    },
    overtime: {
        plural: 'Custom Overtime',
        singular: 'Custom Overtime'
    },
    deduction: {
        plural: 'Deductions',
        singular: 'Deduction'
    }
} 
__p+='\n';
 _.each(['addition', 'overtime', 'deduction'], function(type) { 
__p+='\n    ';
 colspan = (type === 'overtime') ? 10 : 12 
__p+='\n    <table class="table table-striped table-settings table-settings-'+
((__t=( type ))==null?'':_.escape(__t))+
'">\n        <thead>\n            <tr>\n                <th>'+
((__t=( labels[type].plural ))==null?'':_.escape(__t))+
'</th>\n                ';
 if (type === 'overtime') { 
__p+='\n                    <th width="10%">Rate</th>\n                    <th width="6%">PCB</th>\n                    <th width="6%">EPF</th>\n                    <th width="6%">SOCSO</th>\n                    <th width="6%">EIS</th>\n                    <th width="8%">After Working Hours</th>\n                    <th width="8%">Non Working Days</th>\n                    <th width="8%">Holidays</th>\n                    <th width="12%">EA Field</th>\n                ';
 } else { 
__p+='\n                    <th width="6%">Per Unit</th>\n                    <th width="6%">Gross</th>\n                    <th width="6%">Net</th>\n                    <th width="6%">PCB</th>\n                    <th width="6%">EPF</th>\n                    <th width="6%">SOCSO</th>\n                    <th width="6%">EIS</th>\n                    <th width="9.5%">PCB Exempt Limit</th>\n                    <th width="12%">EA Field (Exempt)</th>\n                    <th width="12%">EA Field</th>\n                ';
 } 
__p+='\n            </tr>\n        </thead>\n        <tbody class="list-'+
((__t=( type ))==null?'':_.escape(__t))+
'-empty js-empty-'+
((__t=( type ))==null?'':_.escape(__t))+
'">\n            <tr><td colspan="'+
((__t=( colspan ))==null?'':_.escape(__t))+
'">\n                <h2 class="text-center">\n                    You don\'t have any '+
((__t=( labels[type].plural.toLowerCase() ))==null?'':_.escape(__t))+
'\n                </h2>\n            </td></tr>\n        </tbody>\n        <tbody class="list-'+
((__t=( type ))==null?'':_.escape(__t))+
' js-model-'+
((__t=( type ))==null?'':_.escape(__t))+
'-views"></tbody>\n        ';
 if (typeof hideActionButtons === 'undefined' || !hideActionButtons) { 
__p+='\n        <tfoot>\n            <tr><td colspan="'+
((__t=( colspan ))==null?'':_.escape(__t))+
'">\n                <button class="btn btn-outline pull-right\n                    btn-'+
((__t=( type === 'deduction' ? 'danger' : 'primary' ))==null?'':_.escape(__t))+
'\n                    js-add-'+
((__t=( type ))==null?'':_.escape(__t))+
'\n                    data-loading-text="Adding..."\n                    data-complete-text="+ Add '+
((__t=( labels[type].singular ))==null?'':_.escape(__t))+
'">\n                    + Add '+
((__t=( labels[type].singular ))==null?'':_.escape(__t))+
'\n                </button>\n            </td></tr>\n        </tfoot>\n        ';
 } 
__p+='\n    </table>\n';
 }); 
__p+='\n';
 if (typeof hideActionButtons === 'undefined' || !hideActionButtons) { 
__p+='\n<div class="clearfix">\n    <div class="pull-right">\n        <button class="js-cancel btn btn-warning btn-w-m btn-cancel"\n            data-toggle="tooltip" data-title="No changes will be saved"\n            data-placement="top" data-delayed>\n            <i class="fa fa-exclamation-triangle"></i>\n            Cancel\n        </button>\n        <button class="js-save btn btn-primary m-l-xs">\n            <i class="fa fa-check"></i>\n            Save changes\n        </button>\n    </div>\n</div>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/PayrollItems.ejs
// module id = 702
// module chunks = 1